import { render } from "./업무관련성_평가.vue?vue&type=template&id=18ba7077"
import script from "./업무관련성_평가.vue?vue&type=script&lang=js"
export * from "./업무관련성_평가.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__